import { render, staticRenderFns } from "./ImageCarousel.vue?vue&type=template&id=04c0baac&"
import script from "./ImageCarousel.vue?vue&type=script&lang=js&"
export * from "./ImageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/kunst.dk/http/public/typo3conf/ext/kunst_design/Resources/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('04c0baac', component.options)
    } else {
      api.reload('04c0baac', component.options)
    }
    module.hot.accept("./ImageCarousel.vue?vue&type=template&id=04c0baac&", function () {
      api.rerender('04c0baac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Private/modernjs/components/image-carousel/ImageCarousel.vue"
export default component.exports